import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../../Button'
import { Buttons, MODAL_BUTTONS_VARIANT } from '../../../Modal'
import { MoreActionsButton } from '../../../MoreActionsButton'
import {
  QA_NAME_UPLOAD_IMAGE_CANCEL,
  QA_NAME_UPLOAD_IMAGE_SAVE,
} from '../UploadImageModal.constants'

import { getUploadImageModalSecondaryActions } from './UploadImageModalActions.utils'

function UploadImageModalActions({
  hasImage,
  hasRotateAction,
  hasUndoAction,
  isBusy,
  isMoreCollapsed,
  isSaveDisabled,
  isSkeletonState,
  isSubmitting,
  onClose,
  onReload,
  onRotate,
  onSubmit,
  onUndo,
}) {
  const { t } = useTranslation()

  const secondaryActions = getUploadImageModalSecondaryActions({
    hasImage,
    hasRotateAction,
    hasUndoAction,
    isBusy,
    t,
    onReload,
    onRotate,
    onUndo,
  })

  return (
    <Buttons variant={MODAL_BUTTONS_VARIANT.REGULAR}>
      <Button.Contained
        disabled={isSaveDisabled}
        isLoading={isSubmitting}
        isSkeleton={isSkeletonState}
        qaName={QA_NAME_UPLOAD_IMAGE_SAVE}
        text={t('Modal.SaveBtnKey')}
        onClick={onSubmit}
      />
      <Button.Outlined
        isSkeleton={isSkeletonState}
        qaName={QA_NAME_UPLOAD_IMAGE_CANCEL}
        text={t('Modal.CancelBtnKey')}
        onClick={onClose}
      />
      {isMoreCollapsed ? (
        <MoreActionsButton
          actions={secondaryActions.map(action => ({
            Component: Button.Flat,
            disabled: action.disabled,
            height: BUTTON_HEIGHT_40,
            isGrey: true,
            key: action.key,
            qaName: action.qaName,
            text: action.text,
            onClick: action.onClick,
          }))}
          disabled={isBusy}
          text={t('Common.More')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      ) : (
        secondaryActions.map(action => (
          <Button.Text
            beforeIconProps={action.Icon ? { Icon: action.Icon } : null}
            disabled={action.disabled}
            isSkeleton={isSkeletonState}
            key={action.key}
            qaName={action.qaName}
            text={action.text}
            onClick={action.onClick}
          />
        ))
      )}
    </Buttons>
  )
}

export default UploadImageModalActions
